export const USER_ENDPOINT = {
  GetUsersBySchool: 'users/Users/School/{schoolId}',
  CreateUser: 'users/User',
  SetSchoolAccess: 'users/Users/SchoolAccess/{schoolId}/{type}',
  GetUsersByUserType: 'users/Users/{usertype}',
  UpdateUser: 'users/User',
  CheckEmail: 'users/Users/Email',
  SendWelcomeEmail: 'users/User/Email',
  GetUserByUserId: 'users/User/{userId}',
  GetProductsByUserId: 'users/User/{UserId}/Products' // Inside User FA
};
